import { ActionsFilter, ResGetActions } from "../types/actions";
import { BaseSettingsEndpoints } from "./base";

const ACTIONS_BASE_PATH = "/v1/actions";

export class ActionsClient extends BaseSettingsEndpoints {
  async list(params: ActionsFilter) {
    // formatGenericParams appends arrays as repeated params and drops empties.
    const query = this.formatGenericParams({
      entity: params.entity ?? [],
      action: params.action ?? [],
      source: params.source ?? [],
      office_id: params.office_id ?? [],
      subject_user_id: params.subject_user_id ?? [],
      actor_user_id: params.actor_user_id ?? [],
      from: params.from ?? null,
      to: params.to ?? null,
      limit: params.limit ?? null,
      cursor: params.cursor ?? null
    }).toString();

    return this.get<ResGetActions>(
      query ? `${ACTIONS_BASE_PATH}?${query}` : ACTIONS_BASE_PATH
    );
  }
}
